import React, { useCallback, useMemo, useState } from "react";
import ResizeObserver from "react-resize-observer";
import styled from "styled-components";

const Transition = styled.div<{ duration?: number }>`
    position: relative;
    overflow: hidden;
    transition: height ease ${({ duration = 300 }) => duration}ms;
`;

const RelativeContainer = styled.div`
    position: relative;
    overflow: hidden;
`;

export const AnimateAutoHeight: React.FC<{ overflowOffset?: number }> = ({
    children,
    overflowOffset = 0,
}) => {
    const [height, setHeight] = useState("auto");

    const onResize = useCallback(
        ({ height: newHeight }) => setHeight(newHeight),
        [setHeight],
    );

    const style = useMemo(
        () => ({
            height,
            margin: -overflowOffset,
        }),
        [height, overflowOffset],
    );

    return (
        <Transition className="AnimateAutoHeight" style={style}>
            <RelativeContainer className="AnimateAutoHeight_Relative">
                <ResizeObserver onResize={onResize} />
                <div style={{ padding: overflowOffset }}>{children}</div>
            </RelativeContainer>
        </Transition>
    );
};
